module.exports = __webpack_public_path__ + "static/media/message.03e35318.svg";